import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { fuseAnimations } from "@fuse/animations";
import { ServicioCotizadoDTO } from "app/main/apps/shared/interfaces/servicio-cotizado.interface";

@Component({
    selector: "app-dialog-solicitar-servicio",
    templateUrl: "./dialog-solicitar-servicio.component.html",
    styleUrls: ["./dialog-solicitar-servicio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DialogSolicitarServicioComponent implements OnInit {
    formSolicitarServicio: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DialogSolicitarServicioComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: ServicioCotizadoDTO,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formSolicitarServicio = this.fb.group({ 
            ticket: [null, { validators: [Validators.maxLength(20)] }]
        });
    }

    get ticket() {
        return this.formSolicitarServicio.get("ticket");
    }

    cerrar(): void {
        this.dialogRef.close();
    }
}
